module.exports = __webpack_public_path__ + "img/txtImg.a4154d36.png";